import { v4 as uuid } from 'uuid';
import { toUUID } from '../../util/transform';
import type { ITicketPersonalLoan } from './TicketPersonalLoan.interface';
import TicketPersonalLoanDetails from './TicketPersonalLoanDetails';
import TicketPersonalLoanFees from './TicketPersonalLoanFees';

export default class TicketPersonalLoan implements ITicketPersonalLoan {
  id: string;
  details: TicketPersonalLoanDetails;
  fees: TicketPersonalLoanFees;

  static build = (data: ITicketPersonalLoan) => new TicketPersonalLoan(data);
  static blank = () => new TicketPersonalLoan({ id: uuid() });

  /**
   * Constructor
   * @param {ITicketPersonalLoan} data
   */
  constructor(data?: ITicketPersonalLoan) {
    this.id = toUUID(data?.id) || uuid();
    this.details = new TicketPersonalLoanDetails(data?.details);
    this.fees = new TicketPersonalLoanFees(data?.fees);
  }
}
